import { on } from 'delegated-events'
import scrollTo from '@common/scroll-to'
import ajax from '@common/ajax'

const cache = {}

const handleLoadEventSpace = async (e) => {
  const element = e.target.closest('.element-eventspaces')
  const endpoint = e.currentTarget.dataset.eventSpaceLink

  const pageContent = element.querySelector('[data-page-content]')

  if (pageContent) {
    pageContent.classList.add('is-loading')

    if (endpoint in cache) {
      pageContent.innerHTML = cache[endpoint]
    } else {
      const res = await ajax.get(endpoint).text()

      pageContent.innerHTML = res
      cache[endpoint] = res
    }

    pageContent.classList.remove('is-loading')

    scrollTo(element)
  }
}

document.querySelectorAll('.element-eventspaces').forEach((el) => {
  const pageContent = el.querySelector('[data-page-content]')

  cache[`${el.dataset.id}_default`] = pageContent.innerHTML
})

on('click', '[data-event-space-link]', handleLoadEventSpace)
